import React from 'react';

import { YatLogo } from '@pkg/assets/brand';

import { Container, Heading, SubHeading, YatHandContainer } from './DepGroupGridNotification.style';

export interface DepGroupGridNotificationProps {
    heading: string;
    subheading?: string;
}

export const DepGroupGridNotification = ({ heading, subheading }: DepGroupGridNotificationProps) => {
    return (
        <Container>
            <YatHandContainer>
                <YatLogo aria-hidden="true" opacity={0.1} />
            </YatHandContainer>

            <Heading>{heading}</Heading>
            {subheading && <SubHeading>{subheading}</SubHeading>}
        </Container>
    );
};
